module.exports = __webpack_public_path__ + "img/top3.dde21ee0.svg";